import { render } from "./AddFaq.vue?vue&type=template&id=13fcd2a0&ts=true"
import script from "./AddFaq.vue?vue&type=script&lang=ts"
export * from "./AddFaq.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__